import { Component, inject, Input } from "@angular/core";
import { Router } from "@angular/router";

import { ButtonComponent } from "@shared/components/button/button.component";
import { CacheId } from "@shared/enums";
import { GlobalService } from "@shared/services";

@Component({
  selector: "app-sub-page",
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: "./sub-page.component.html",
  styleUrl: "./sub-page.component.scss",
})
export class SubPageComponent {
  globalService = inject(GlobalService);
  router = inject(Router);
  @Input() pageTitle: string = "";
  @Input() navBackRoute: string = "";

  getContentHeight(): string {
    return `calc(100vh - (${this.globalService.navbarHeight()}px + 50px))`;
  }

  navigateBack(): void {
    this.router.navigate([this.navBackRoute]);
  }
}
